import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import Box from '@tds/core-box';

export const TableWrapper = styled.table`
  width: 100%;
  @media screen and (max-width: 992px) {
    overflow-y: scroll;
    display: block;
  }
`;

export const Th = styled.td`
  color: #595859;
  background-color: #e2e2e2;
  padding: 0.4rem;
  text-align: center;
  cursor: pointer;
  font-weight: 500;
`;

export const Td = styled.td`
  padding: 0.5rem;
  text-align: center;
  ${props =>
    props.actionStyles &&
    css`
      display: flex;
      justify-content: center;
    `}
`;

Td.propTypes = {
  actionStyles: PropTypes.bool
};

export const Tr = styled.tr`
  background-color: ${props => (props.isOdd ? '#f9fafa' : '#f9f1ff')};
`;

Tr.propTypes = {
  isOdd: PropTypes.number
};

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  min-height: 20px;
`;

export const PageWrapper = styled(Box)`
  text-align: center;
  width: auto;
  height: 25px;
  padding: 2px 6px;
  margin: 2px;
  font-size: 0.85rem;
  font-weight: ${props =>
    props.pageNumber === props.isSelected ? '600' : '400'};
  color: ${props =>
    props.pageNumber === props.isSelected ? '#ffffff' : '#49166d'};
  background-color: ${props =>
    props.pageNumber === props.isSelected ? '#a2a2a2' : '#ffffff'};
`;

PageWrapper.propTypes = {
  pageNumber: PropTypes.number,
  isSelected: PropTypes.bool
};

PageWrapper.defaultProps = {
  pageNumber: undefined,
  isSelected: false
};
